import { Component, NgZone, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor(private ngZone: NgZone) {}

  ngOnInit(): void {
    // Initialization logic here
    console.log('Outside name:', Zone.current.name); // If <root>, Angular hasn't initialized yet
    this.ngZone.run(() => {
      console.log('Inside name:', Zone.current.name); // Should be 'angular'
    });
  }
}
